import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';

export const templateMaintenanceWindowSelector = document.createElement('template');

templateMaintenanceWindowSelector.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <gz-title id="title" fontsize="20"></gz-title>
    <gz-text id="description" fontsize="12"></gz-text>

    <div class="dropdown-container">
        <label id="selector-label" for="selector"></label>
        <gz-dropdown id="selector"></gz-dropdown>
    </div>
    <div id="preview-wrapper" hidden="hidden">
      <div id="preview-container"></div>
      <gz-button id="edit-button" hidden="hidden" type="quiet" color="primary" buttonheight="small" buttonfontsize="medium"></gz-button>
    </div>
  </div>
`;
